import { type ProductSortEnum } from '../../__generated__/graphql-client-types';

const ProductSort = new Set(['BEST_MATCH', 'PRICE_HI_LOW', 'PRICE_LOW_HI', 'RATING']);

const isProductSortValue = (value?: string | null): value is ProductSortEnum => {
	return Boolean(ProductSort.has(value || ''));
};

export const convertToProductSortEnum = (value?: string | null): ProductSortEnum => {
	const upperCased = value?.toUpperCase();
	return isProductSortValue(upperCased) ? upperCased : 'BEST_MATCH';
};
